"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductColorStyleSearchModel = instanceOfProductColorStyleSearchModel;
exports.ProductColorStyleSearchModelFromJSON = ProductColorStyleSearchModelFromJSON;
exports.ProductColorStyleSearchModelFromJSONTyped = ProductColorStyleSearchModelFromJSONTyped;
exports.ProductColorStyleSearchModelToJSON = ProductColorStyleSearchModelToJSON;
exports.ProductColorStyleSearchModelToJSONTyped = ProductColorStyleSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductColorStyleSearchModel interface.
 */
function instanceOfProductColorStyleSearchModel(value) {
    return true;
}
function ProductColorStyleSearchModelFromJSON(json) {
    return ProductColorStyleSearchModelFromJSONTyped(json, false);
}
function ProductColorStyleSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'colorName': json['colorName'] == null ? undefined : json['colorName'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
    };
}
function ProductColorStyleSearchModelToJSON(json) {
    return ProductColorStyleSearchModelToJSONTyped(json, false);
}
function ProductColorStyleSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'colorName': value['colorName'],
        'useStatus': value['useStatus'],
    };
}
